import moment from 'moment';
import _ from 'lodash';
import { lsDeviceHelpers } from 'ls-vue-common';

function generateShortLinkWithDate({ short_link }) {
  return short_link ? `${short_link}/${moment().format('YYYYMMDD')}` : '';
}

function generateCopyMessageWithShortLink({ message_default_copy, short_link }) {
  const shortLinkWithDate = generateShortLinkWithDate({ short_link });

  if (message_default_copy && shortLinkWithDate) {
    return `${message_default_copy} ${shortLinkWithDate}`;
  }

  return message_default_copy || shortLinkWithDate;
}

function getURL({ platform, sites }) {
  const urls = {
    nextdoor: _.get(sites, `nextdoor`) || 'https://www.nextdoor.com',
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${platform.shortLinkWithDate}`,
    twitter: `https://twitter.com/intent/tweet?url=${platform.shortLinkWithDate}&text=${
      platform.message_default_copy
    }`,
    google:
      _.get(sites, `google`) ||
      'https://www.google.com/search?q=lawnstarter#lrd=0x8644b5acb912d45d:0x6db33a239f8bceb0,3,,',
    sms: `${lsDeviceHelpers.isIOS() ? 'sms:&body=' : 'sms:?body='}${
      platform.copyMessageWithShortLink
    }`,
  };

  return urls[platform.platformName];
}

function generatePlatformWithUIData({ platform, iconsAndColor = {} }) {
  // not using spread here for more clarity on what values are coming from iconsAndColor
  let displayValues = {};
  if (!_.isEmpty(iconsAndColor)) {
    displayValues = {
      platformName: iconsAndColor.platformName,
      buttonIcon: iconsAndColor.buttonIcon,
      accentColor: iconsAndColor.accentColor,
    };
  }

  const data = {
    ...platform,
    ...displayValues,
    shortLinkWithDate: generateShortLinkWithDate(platform),
    copyMessageWithShortLink: generateCopyMessageWithShortLink(platform),
  };

  if (data.platformName === 'link' && !data.button_text) {
    data.button_text = 'Copy Personal Share Link';
  }

  return data;
}

//eslint-disable-next-line import/prefer-default-export
export const lsShareStoreHelpers = {
  generateShortLinkWithDate,
  generateCopyMessageWithShortLink,
  getURL,
  generatePlatformWithUIData,
};
